<template>
  <div :class="cn('flex flex-col gap-0.5', props.class)">
    <Action
      v-for="action in actions"
      :key="action.id"
      :title="getActionTitle(action.id)"
      :icon="action.icon"
      :disabled="action.disabled"
      @click.stop="$emit('goToStep', action.id)"
    />
  </div>
</template>

<script setup>
import { Action, useActions } from "@/SharedComponents/BulkActions";
import { cn } from "@/Utils/cn";

defineEmits(["goToStep"]);

const props = defineProps({
  actions: { type: Array, required: true },
  class: { type: String, required: false },
});

const { getActionTitle } = useActions();
</script>
